import {
  Box,
  Center,
  Heading,
  Link,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import theme from "@common/theme";
import Icon from "@modules/Icon";
import React, { FC } from "react";
import { Button } from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import ResponsiveContainer from "./ResponsiveContainer";
import useCalendlyModal from "../hooks/useCalendlyModal";

const logos = [
  {
    icon: "tool",
    text: "Need support?",
    link: "https://support.commdevices.com/portal/en/signin",
    mobileLink: "https://support.commdevices.com/portal/en/signin",
    isExternal: true,
    target: "_blank",
  },
  {
    icon: "phone",
    text: "Call an Expert",
    mobileLink: "tel:1-800-359-8561",
    link: "/contact-us",
    isExternal: true,
    target: "_self",
  },
  {
    icon: "email",
    text: "Email us",
    link: "mailto:info@commdevices.com",
    mobileLink: "mailto:info@commdevices.com",
    isExternal: true,
    target: "_self",
  },
];
const ContactExpert: FC = props => {
  return (
    <Box>
      <ResponsiveContainer>
        <Box maxW="2xl" mx="auto">
          <Stack justify="flex-start" align="center" spacing="20px" mt={10}>
            <Heading as="h1" textAlign={{ md: "center" }} mb={3}>
              Talk to an expert
            </Heading>
            <Text align={"center"} textStyle="hind_r" fontSize={"h4"}>
              Ready to know more? Call us on <b>1 800 359-8561</b> or schedule a
              demo of our Out of Band Management products and solutions.
            </Text>
          </Stack>
        </Box>
        <Center mt={9} mb={14}>
          <Button as={GatsbyLink} to="/schedule-a-demo/" variant="primary">
            Schedule a Demo
          </Button>
        </Center>
      </ResponsiveContainer>
      <Box bg={"primary700"} p={{ base: 4, lg: 8 }}>
        <Box maxW={theme.breakpoints.lg} mx="auto">
          <Center>
            {logos.map((item, index) => {
              const linkText = useBreakpointValue({
                base: item.mobileLink,
                md: item.link,
              });

              return (
                <Link
                  key={index}
                  href={linkText}
                  isExternal
                  target={item.target}
                  _hover={{ textDecoration: "none" }}
                >
                  <Stack
                    mx={{ base: 0, md: 4, lg: 7 }}
                    key={index}
                    direction={{ base: "column", md: "row" }}
                    align="center"
                    spacing={4}
                  >
                    <Center height="2.5rem" width="auto">
                      <Icon name={item.icon} />
                    </Center>
                    <Text
                      color={"white"}
                      textAlign={{ base: "center" }}
                      px={{ base: 4, md: 0 }}
                      pt={1}
                    >
                      {item.text}
                    </Text>
                  </Stack>
                </Link>
              );
            })}
          </Center>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactExpert;
